import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';
import { restoreScores } from '../function/handle-check-list.function';

import { ReceiveResult } from './receive-result.action';

export function receiveResultReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__RECEIVE_RESULT,
        ReceiveResult
    >,
): CaAnalysisDialogState {
    restoreScores(action.payload.result);
    return {
        ...state,
        result: action.payload.result,
    };
}
